import { Button, Card, Modal, useInitialFocus } from '@playerbase/ui';

type ArchiveBuildDialogProps = {
  open: boolean;
  buildLabel: string;
  busy: boolean;
  onConfirm: () => void;
  onCancel: () => void;
};

// Archive is the only terminal action — markers are never deleted because
// Issues and Pool records reference them. Copy is explicit so the user
// understands they're not losing the audit trail, just hiding the row.
export function ArchiveBuildDialog({
  open,
  buildLabel,
  busy,
  onConfirm,
  onCancel,
}: ArchiveBuildDialogProps): JSX.Element {
  const cancelRef = useInitialFocus<HTMLButtonElement>();

  return (
    <Modal
      open={open}
      onClose={onCancel}
      busy={busy}
      labelledById="archive-build-title"
      initialFocusRef={cancelRef}
    >
      <Card>
        <Card.Header>
          <Card.Title id="archive-build-title">Archive {buildLabel}?</Card.Title>
          <Card.Description>
            Hides this build from the default list. References from Issues and feedback records stay intact.
          </Card.Description>
        </Card.Header>
        <Card.Content>
          <p className="text-sm text-text-muted leading-relaxed">
            You can unarchive later from the show-archived view. Build markers can&apos;t be permanently deleted because other parts of the platform link back to them.
          </p>
        </Card.Content>
        <Card.Footer className="justify-end">
          <Button
            ref={cancelRef}
            variant="ghost"
            size="md"
            onClick={onCancel}
            disabled={busy}
          >
            Cancel
          </Button>
          <Button variant="danger" size="md" onClick={onConfirm} disabled={busy}>
            {busy ? 'Archiving…' : 'Archive build'}
          </Button>
        </Card.Footer>
      </Card>
    </Modal>
  );
}
